import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ShieldCheck, Plus, Globe, X } from "lucide-react";

// Trusted retailer domains (auto-post allowlist). State/handlers from AdminDashboard.
export const DomainsTab = ({ domains, newDomain, setNewDomain, addDomain, removeDomain }) => (
  <div className="max-w-2xl">
    <div className="rounded-xl border border-black/10 bg-white p-5">
      <div className="flex items-center gap-2 font-semibold text-sm">
        <ShieldCheck className="h-4 w-4 text-accent" /> Trusted retailer domains
      </div>
      <p className="mt-1 text-sm text-muted-foreground">
        Deals whose URL matches one of these domains are auto-posted (after passing the content check).
        Others go to the Submissions queue for review.
      </p>
      <div className="mt-4 flex gap-2">
        <Input
          value={newDomain} data-testid="new-domain-input"
          onChange={(e) => setNewDomain(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && addDomain()}
          placeholder="e.g. walmart.ca"
        />
        <Button data-testid="add-domain-btn" onClick={addDomain} className="rounded-full shrink-0">
          <Plus className="mr-1 h-4 w-4" /> Add
        </Button>
      </div>
      <div className="mt-5 flex flex-wrap gap-2">
        {domains.length === 0 ? (
          <p className="text-sm text-muted-foreground">No trusted domains yet.</p>
        ) : (
          domains.map((d) => (
            <span
              key={d.domain} data-testid={`domain-${d.domain}`}
              className="inline-flex items-center gap-2 rounded-full border border-black/10 bg-secondary px-3 py-1 text-sm"
            >
              <Globe className="h-3.5 w-3.5 text-muted-foreground" />
              {d.domain}
              <button
                data-testid={`remove-domain-${d.domain}`}
                onClick={() => removeDomain(d.domain)}
                className="text-muted-foreground hover:text-destructive"
              >
                <X className="h-3.5 w-3.5" />
              </button>
            </span>
          ))
        )}
      </div>
    </div>
  </div>
);

export default DomainsTab;
